import type { Issue } from '../../../common/types';
import type { DeploymentsByIssueId } from '../types';

export const sortIssueByLatestDeploymentsAndLocateEmptyDeploymentsLast = (
	issues: Issue[],
	deploymentsByIssueId: DeploymentsByIssueId,
): Issue[] =>
	issues.sort((issue1: Issue, issue2: Issue) => {
		if (
			deploymentsByIssueId[issue1.id] === undefined &&
			deploymentsByIssueId[issue2.id] === undefined
		) {
			return 0;
		}
		if (deploymentsByIssueId[issue1.id] === undefined) {
			return 1;
		}
		if (deploymentsByIssueId[issue2.id] === undefined) {
			return -1;
		}

		return (
			deploymentsByIssueId[issue2.id][0].lastUpdated.getTime() -
			deploymentsByIssueId[issue1.id][0].lastUpdated.getTime()
		);
	});
